(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(min-width: 990px)');
    function sync() {
      var details = document.querySelectorAll('.footer__column-details');
      for (var i = 0; i < details.length; i++) {
        if (mq.matches) {
          details[i].setAttribute('open', '');
        } else {
          details[i].removeAttribute('open');
        }
      }
    }
    sync();
    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }
  })();

  // Reveal the "Cookie preferences" control only when Shopify's consent SDK
  // is actually on the page. Rendered as a <button>, not an <a>: the policy's
  // pseudo-URL resolves to /policies/ (a 404), which crawlers would follow.
  (function () {
    var li = document.querySelector('[data-consent-reshow]');
    if (!li) return;
    function banner() {
      return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'
        ? window.privacyBanner
        : null;
    }
    var tries = 0;
    (function check() {
      if (banner() || (window.Shopify && window.Shopify.customerPrivacy)) {
        li.hidden = false;
        return;
      }
      if (++tries < 20) setTimeout(check, 500);
    })();
    li.addEventListener('click', function (e) {
      var pb = banner();
      if (pb) {
        e.preventDefault();
        pb.showPreferences();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class KinetipathHeader extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector('.header__drawer');
      this.toggle = this.querySelector('.header__drawer-toggle');
      this.panel = this.querySelector('.header__drawer-panel');
      this.closeBtns = this.querySelectorAll('[data-drawer-close]');
      this.lastFocus = null;
      this.scrolled = false;

      this.onScroll = this.onScroll.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.openDrawer = this.openDrawer.bind(this);
      this.closeDrawer = this.closeDrawer.bind(this);
      this.trapFocus = this.trapFocus.bind(this);
    }

    connectedCallback() {
      if (this.dataset.sticky === 'true') {
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      if (this.toggle && this.drawer) {
        this.toggle.addEventListener('click', this.openDrawer);
        this.closeBtns.forEach((btn) => btn.addEventListener('click', this.closeDrawer));
        this.drawer.addEventListener('keydown', this.trapFocus);
        document.addEventListener('keydown', this.onKeyDown);

        this.drawer.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', () => this.closeDrawer());
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKeyDown);
    }

    onScroll() {
      const shouldScroll = window.scrollY > 4;
      if (shouldScroll !== this.scrolled) {
        this.scrolled = shouldScroll;
        this.classList.toggle('header-wrapper--scrolled', shouldScroll);
      }
    }

    openDrawer() {
      this.lastFocus = document.activeElement;
      this.drawer.hidden = false;
      requestAnimationFrame(() => {
        this.drawer.classList.add('header__drawer--open');
        this.drawer.setAttribute('aria-hidden', 'false');
        this.toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('header-drawer-open');
        setTimeout(() => {
          const firstLink = this.drawer.querySelector('.header__drawer-close');
          if (firstLink) firstLink.focus();
        }, 240);
      });
    }

    closeDrawer() {
      this.drawer.classList.remove('header__drawer--open');
      this.drawer.setAttribute('aria-hidden', 'true');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('header-drawer-open');
      setTimeout(() => {
        this.drawer.hidden = true;
        if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
          this.lastFocus.focus();
        }
      }, 240);
    }

    onKeyDown(e) {
      if (e.key === 'Escape' && this.drawer.classList.contains('header__drawer--open')) {
        this.closeDrawer();
      }
    }

    trapFocus(e) {
      if (e.key !== 'Tab') return;
      const focusables = this.panel.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('kinetipath-header')) {
    customElements.define('kinetipath-header', KinetipathHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
